import { useState, useEffect } from "react";
import api from "../axiosConfig";
import { TimeZone } from "../types/authTypes";

export const useTimeZones = () => {
  const [timeZones, setTimeZones] = useState<TimeZone[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTimeZones = async () => {
      try {
        const response = await api.get("/app/v1/timezone");
        setTimeZones(response.data.message);
      } catch (err) {
        setError("Failed to fetch time zones");
        console.error("Error fetching time zones:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTimeZones();
  }, []);

  return { timeZones, loading, error };
};
